import { render, staticRenderFns } from "./ZhuanyunCharge.vue?vue&type=template&id=974027a8&scoped=true&"
import script from "./ZhuanyunCharge.vue?vue&type=script&lang=js&"
export * from "./ZhuanyunCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974027a8",
  null
  
)

export default component.exports